(function ($) {
	$.fn.numericUpDown = function (settings) {
		var config = {
			min: 0,
			max: 100
		};
		if (settings) { $.extend(config, settings); }

		return this.each(function () {

			if ($(this).hasClass("NumericUpDownProcessed"))
				return;
				
			$(this).addClass("NumericUpDownProcessed");
			$(this).after('<div class="NumericUpDownButtons"><input type="button" value="" class="plus"/><input type="button" value="" class="minus"/></div>');

			var current = new Number($(this).val());
			if (current > config.max)
				current = config.max;
			if (current < config.min)
				current = config.min;
			if(isNaN(current))
				current = config.min;
			$(this).val(current);

			$(this).next().find(".plus").click(function () {
				var tmp = new Number($(this).parent().prev().val());
				if (tmp < config.max) {
					$(this).parent().prev().val(tmp + 1);
				}
			});

			$(this).next().find(".minus").click(function () {
				var tmp = new Number($(this).parent().prev().val());
				if (tmp > config.min) {
					$(this).parent().prev().val(tmp - 1);
				}
			});
			
			$(this).change(function () {
				var current = new Number($(this).val());
				if (current > config.max)
					current = config.max;
				if (current < config.min)
					current = config.min;
				if(isNaN(current))
					current = config.min;
				$(this).val(current);
			});

		});
	};
})(jQuery);


(function ($) {
	$.fn.DUINumber = function (settingsObject) {
		var configObject = {
			min: -Infinity,
			max: Infinity,
			step: 1,
			decimals: true,
			valueprefix: '',
			valuesufix: ''
		};

		var buttonsHTML = '<div class="DUI-number-buttons">' +
			'<button type="button" class="DUI-number-plus" tabindex="-1"><i class="DUI-icon DUI-icon-a-sort-up"></i></button>' +
			'<button type="button" class="DUI-number-minus" tabindex="-1"><i class="DUI-icon DUI-icon-a-sort-down"></i></button>' +
			'</div>'

		return this.each(function () {
			var inputEl = $(this);
			var attrs;
			var config;

			if (inputEl.hasClass("dui-number-processed"))
				return;

			if (!inputEl.parent().hasClass('DUI-number')) {
				inputEl.wrap('<div class="DUI-number"></div>')
			}

			attrs = {
				min: inputEl.attr('min'),
				max: inputEl.attr('max'),
				step: inputEl.attr('step'),
				decimals: inputEl.attr('decimals'),
				valuesufix: inputEl.attr('valuesufix'),
				valueprefix: inputEl.attr('valueprefix'),
			};

			if (typeof attrs.min === 'string' && attrs.min !== '') attrs.min = Number(attrs.min);
			else delete attrs.min;

			if (typeof attrs.max === 'string' && attrs.max !== '') attrs.max = Number(attrs.max);
			else delete attrs.max;

			if (typeof attrs.step === 'string' && attrs.step !== '') attrs.step = Number(attrs.step);
			else delete attrs.step;

			if (typeof attrs.valueprefix === 'undefined') delete attrs.valueprefix;
			if (typeof attrs.valuesufix === 'undefined') delete attrs.valuesufix;
			if (typeof attrs.decimals === 'undefined') delete attrs.decimals;
			else attrs.decimals = Boolean(attrs.decimals == 'true');

			if (settingsObject === undefined) settingsObject = {};
			config = $.extend({}, configObject, settingsObject, attrs);

			function getCurrentValue() {
				return inputEl.val().replace(config.valueprefix, '').replace(config.valuesufix, '');
			}

			function getCurrentNumber() {
				return Number(getCurrentValue());
			}

			function setCurrentNumber() {
				inputEl.val(config.valueprefix + Number(currentNumber).toFixed(decimalsCount) + config.valuesufix);
			}

			function countDecimals(value) {
				var decimals = value.split('.')[1];
				return decimals ? decimals.length : 0;
			}

			function roundNumber(number, decimals) {
				var newnumber = Number(number + '').toFixed(parseInt(decimals));
				return parseFloat(newnumber);
			}

			function getDecimalStep(decimalsCount) {
				var step = 1;

				if (decimalsCount > 0) {
					return 1 / parseInt(1 + Array(decimalsCount + 1).join(0));
				}

				return step;
			}

			inputEl.addClass("dui-number-processed");
			inputEl.after(buttonsHTML);

			var currentValue = getCurrentValue();
			var currentNumber = getCurrentNumber();
			var decimalsCount = countDecimals(currentValue);

			if (currentValue.length > 0) {
				if (currentNumber > config.max)
					currentNumber = config.max;
				if (currentNumber < config.min)
					currentNumber = config.min;

				if (isNaN(currentNumber))
					currentNumber = config.min;

				setCurrentNumber();
			}

			inputEl.next().find(".DUI-number-plus").click(function () {
				var tmp = getCurrentNumber();
				var maxAttr = inputEl.attr('max');
				var stepAttr = inputEl.attr('step');
				var maxNumber = maxAttr === '' ? NaN : Number(maxAttr);
				var stepNumber = stepAttr === '' ? NaN : Number(stepAttr);
				var max = !isNaN(maxNumber) ? maxNumber : config.max;
				var step = !isNaN(stepNumber) ? stepNumber : config.step;
				var stepDecimals = !isNaN(stepNumber) ? countDecimals(stepAttr) : 0;
				decimalsCount = Math.max(decimalsCount, stepDecimals);
				if (!inputEl.is(':disabled') && tmp < max) {
					currentNumber = roundNumber(tmp + step, decimalsCount);
					setCurrentNumber();
					inputEl.trigger('change');
				}
			});

			inputEl.next().find(".DUI-number-minus").click(function () {
				var tmp = getCurrentNumber();
				var minAttr = inputEl.attr('min');
				var stepAttr = inputEl.attr('step');
				var minNumber = minAttr === '' ? NaN : Number(minAttr);
				var stepNumber = stepAttr === '' ? NaN: Number(stepAttr);
				var min = !isNaN(minNumber) ? minNumber : config.min;
				var step = !isNaN(stepNumber) ? stepNumber : config.step;
				var stepDecimals = !isNaN(stepNumber) ? countDecimals(stepAttr) : 0;
				decimalsCount = Math.max(decimalsCount, stepDecimals);
				if (!inputEl.is(':disabled') && tmp > min) {
					currentNumber = roundNumber(tmp - step, decimalsCount);
					setCurrentNumber();
					inputEl.trigger('change');
				}
			});

			inputEl.bind('change', function () {
				currentValue = getCurrentValue();
				currentNumber = getCurrentNumber();

				// TFS 10778: not a number after prefix and suffix was removed? try to remove invalid characters
				if (isNaN(currentNumber)) {
					if (config.decimals)
						currentValue = currentValue.replace(/[^0-9.,]/g, '');
					else
						currentValue = currentValue.replace(/[^0-9]/g, '');

					currentNumber = Number(currentValue);
				}

				decimalsCount = countDecimals(currentValue);

				var minAttr = inputEl.attr('min');
				var maxAttr = inputEl.attr('max');
				var minNumber = minAttr === '' ? NaN : Number(minAttr);
				var maxNumber = maxAttr === '' ? NaN : Number(maxAttr);

				config.min = !isNaN(minNumber) ? minNumber : config.min;
				config.max = !isNaN(maxNumber) ? maxNumber : config.max;
				config.step = getDecimalStep(decimalsCount);

				if (currentValue.length === 0)
					return;

				if (currentNumber > config.max)
					currentNumber = config.max;
				if (currentNumber < config.min)
					currentNumber = config.min;
				
				if (isNaN(currentNumber))
					currentNumber = config.min;

				setCurrentNumber();
			});

			inputEl.bind('keypress', function (event) {
				// Allow: del, backspace and arrow keys. Note keypress event code for backspace is 8 and 0 for delete and arrow key
				if (event.which === 8 || event.which === 0)
					return;
				// dash, dot, but only if decimals are allowed
				if (config.decimals && (event.which === 45 || event.which === 46)) {
					return;
				}
				// Ensure that it is a number and stop the keypress
				else if (event.which > 47 && event.which < 58) {
					return;
				} else {
					event.preventDefault();
				}
			})

		});
	};
})(jQuery);